import { Component, ComponentInterface, h, Host, Prop } from "@stencil/core";

/**
 * @slot (default) - Image or custom content
 */
@Component({
    tag: "uic-thumbnail-item",
    styleUrl: "thumbnail-item.scss"
})
export class ThumbnailItem implements ComponentInterface {
    /**
     * If set to `true`, indicates that the thumbnail is the selected one inside a thumbnail list.
     */
    @Prop() readonly selected: boolean = false;

    /**
     * If set to `true`, indicates that the content of the thumbnail item is a placeholder.
     */
    @Prop() readonly placeholder: boolean = false;

    /**
     * The name of the icon to show next to the thumbnail content.
     */
    @Prop() readonly icon: string;

    render() {
        return (
            <Host
                class={{
                    "uic-thumbnail-item": true,
                    "uic-thumbnail-item--selected": this.selected,
                    "uic-thumbnail-item--placeholder": this.placeholder
                }}
                tabindex='0'
            >
                <slot></slot>
                {this.icon && [
                    <div class='uic-thumbnail-item__icon-bg'></div>,
                    <uic-icon name={this.icon} size='small' class='uic-thumbnail-item__icon'></uic-icon>
                ]}
            </Host>
        );
    }
}
